export type ArticleMeta = {
  slug: string;
  title: string;
  description: string;
  eyebrow: string;
  readMinutes: number;
  date: string; // ISO date (YYYY-MM-DD)
};

export const articleMetas: ArticleMeta[] = [
  {
    slug: "how-many-training-zones",
    title: "How many training zones do you need?",
    description:
      "Three, five, seven or nine zones? The body has two important boundaries, and fixed percentages of a maximum put different runners in different states.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "fixed-or-adaptive-plan",
    title: "Fixed plan or a plan that adjusts?",
    description:
      "Recreational runners whose plan was adjusted to their recovery improved their 10K by 6.2 percent, against 2.9 percent on a fixed plan. Breaks in training are the norm, not the exception.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "is-80-20-best",
    title: "Is 80/20 the best way to train?",
    description:
      "Where the 80/20 rule comes from, and why a review of 13 studies suggests recreational runners may do better with a little more moderate running.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "norwegian-method",
    title: "What is the Norwegian method?",
    description:
      "Three to four controlled threshold sessions a week on top of 150 to 180 km of running. What the model involves and what a recreational runner can borrow.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "elite-distance-runners",
    title: "How the world's best distance runners train",
    description:
      "11 to 14 sessions and up to 220 km a week, at least 80 percent of it easy. What carries over to recreational runners and what doesn't.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "critical-speed-without-a-lab",
    title: "Can you find your critical speed without a lab?",
    description:
      "Critical speed marks the fastest pace you can sustain without fatigue building steadily. Studies show it can be estimated from your own runs and a few time trials.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "why-running-injuries-happen",
    title: "Why running injuries happen",
    description:
      "Injuries develop when the load on a tendon, bone or muscle exceeds what it can handle that day. Why a single long run matters more than a weekly ratio.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "strength-training-for-runners",
    title: "Should runners lift weights?",
    description:
      "Strength training improved running economy by 2 to 8 percent in most of 24 studies, without making runners heavier.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "carbohydrate-during-a-marathon",
    title: "How much carbohydrate do you need in a marathon?",
    description:
      "For an hour, a sip or a rinse is enough. Beyond two hours, the amount matters, and the best results came with around 90 grams an hour.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "carbon-plated-shoes",
    title: "How much do carbon-plated shoes help?",
    description:
      "In the first study of the new racing shoes, all 18 runners used less energy, about 4 percent on average.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "running-in-the-heat",
    title: "How much does heat slow you down?",
    description:
      "Marathon times got slower as heat stress increased, most for slower runners. One to two weeks of training in the heat helps.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "menstrual-cycle-and-running",
    title: "Should you train around your menstrual cycle?",
    description:
      "A meta-analysis of 78 studies found at most a trivial effect of cycle phase on performance, and no basis for general rules.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "running-cadence",
    title: "Should you change your running cadence?",
    description:
      "A 5 to 10 percent higher step rate reduced the load on the knee and hip. When it is worth changing and how to do it.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "predict-marathon-time",
    title: "Can you predict your marathon from a 10K?",
    description:
      "The most common formula works well up to the half marathon, but predicted marathon times at least 10 minutes too fast for half of 2,303 recreational runners.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "how-little-training-keeps-fitness",
    title: "How little training keeps your fitness?",
    description:
      "Fewer and shorter sessions kept fitness for 15 weeks. Easier sessions did not. What to keep when life gets busy.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "sleep-and-running",
    title: "Sleep and running",
    description:
      "Athletes who slept almost two hours more per night got faster and felt less tired. What sleep loss costs and what to do about it.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "recovery-methods",
    title: "Which recovery methods actually work?",
    description:
      "A meta-analysis of 99 studies compared massage, compression, cold water, stretching and more. Massage did best for soreness and fatigue.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "stretching-before-running",
    title: "Should you stretch before running?",
    description:
      "Long static stretches lowered performance right afterwards, dynamic stretching improved it. How to warm up instead.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "caffeine-and-running",
    title: "Does caffeine make you faster?",
    description:
      "Caffeine improves endurance performance, typically at 3 to 6 mg per kg of body weight about an hour before. How to try it safely.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "how-much-to-drink",
    title: "How much should you drink when you run?",
    description:
      "13 percent of Boston Marathon runners had too little sodium in the blood, mostly from drinking too much. Why thirst is a good guide.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "treadmill-or-outside",
    title: "Treadmill or outside?",
    description:
      "A 1 percent incline makes treadmill running cost the same energy as running outside. How to use your pace targets indoors.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "running-as-you-get-older",
    title: "Running as you get older",
    description:
      "Endurance holds up until about 35 and falls modestly until 50 to 60. Much of the decline comes from training less and slower.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "eating-enough-to-train",
    title: "Eating enough to train",
    description:
      "Eating too little for the training you do can affect health and running, in both women and men. The warning signs to take seriously.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "the-10-percent-rule",
    title: "Does the 10 percent rule prevent injuries?",
    description:
      "In a trial with 532 new runners, a programme built on the 10 percent rule gave the same injury rate as a faster one. Large jumps are still worth avoiding.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-15",
  },
  {
    slug: "mental-fatigue",
    title: "Why runs feel harder after a long day",
    description:
      "After 90 minutes of demanding mental work, people gave up about 15 percent sooner. Their body was the same, but the effort felt harder.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-15",
  },
  {
    slug: "overreaching-and-overtraining",
    title: "When does tiredness become overtraining?",
    description:
      "Planned tiredness makes you better. Tiredness that doesn't pass can become a problem. How to tell the difference.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-15",
  },
  {
    slug: "wrist-heart-rate",
    title: "How accurate is heart rate from your watch?",
    description:
      "Wrist sensors did well on a treadmill and varied more in other activities. A chest strap was almost identical to an ECG.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-15",
  },
  {
    slug: "intervals-or-steady-running",
    title: "Intervals or steady running?",
    description:
      "Both gave large gains in maximal oxygen uptake across 28 studies. Intervals gave a little more.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-15",
  },
  {
    slug: "hill-intervals",
    title: "What do hill intervals do?",
    description:
      "Six weeks of uphill intervals improved 5 km times by 2 percent in well-trained runners, whatever the programme.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-15",
  },
  {
    slug: "music-and-running",
    title: "Does music make you run better?",
    description:
      "Across 139 studies, music improved mood and performance and made the effort feel a little easier.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-15",
  },
  {
    slug: "holding-up-late-in-a-run",
    title: "Why holding up late in a run matters",
    description:
      "After two hours of hard exercise, critical power fell by about 10 percent on average, from under 1 to about 32 percent. Why durability matters for long runs and races.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "watch-vo2max",
    title: "Can you trust your watch's VO₂max?",
    description:
      "A review of 14 studies found watch estimates close on average, but often up to about 10 ml/kg/min off for the individual runner.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "interval-length",
    title: "4 × 4, 4 × 8 or 4 × 16 minutes?",
    description:
      "In a seven-week study, 4 × 8 minutes at a hard but controlled effort gave more than both shorter, harder and longer intervals.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "how-hard-did-it-feel",
    title: "Why we ask how hard the run felt",
    description:
      "Rating the whole session from 0 to 10 and multiplying by the minutes is a simple, well-tested way to measure training load, also for intervals.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "coming-back-after-a-break",
    title: "Coming back after a break",
    description:
      "In about 300,000 marathon runners, breaks of a week or more were linked to finishing 5 to 8 percent slower. How to start again after illness or a holiday.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "marathon-pacing",
    title: "Don't start your marathon too fast",
    description:
      "In more than 25,000 recreational runners, a fast first half made a big slowdown in the second half much more likely.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-12",
  },
  {
    slug: "rest-between-intervals",
    title: "How long should you rest between intervals?",
    description:
      "Runners doing 6 × 4 minutes ran slightly faster with two minutes of rest than with one. Four minutes did not help further.",
    eyebrow: "Research",
    readMinutes: 3,
    date: "2026-10-12",
  },
  {
    slug: "how-long-can-your-long-run-be",
    title: "How much longer can your long run be?",
    description:
      "A Danish-led study of 5,205 runners found more overuse injuries when a run was over 10 percent longer than the longest run in the previous month.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-11",
  },
  {
    slug: "train-by-recovery",
    title: "Training by how recovered you are",
    description:
      "Recreational runners who adjusted their training to heart rate variability and how they felt improved their 10K more than runners on a fixed plan.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-11",
  },
  {
    slug: "marathon-taper",
    title: "Three weeks of tapering before a marathon",
    description:
      "In more than 158,000 marathon runners, a steady three-week taper was linked to finishing about 2.6 percent faster.",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-11",
  },
  {
    slug: "heart-rate-drift",
    title: "Why your heart rate climbs late in a marathon",
    description:
      "An analysis of 82,303 marathon runners linked changes in heart rate relative to speed with race performance. What does that tell us about training?",
    eyebrow: "Research",
    readMinutes: 4,
    date: "2026-10-11",
  },
  {
    slug: "targets-and-ranges",
    title: "Your pace and power targets",
    description:
      "How PX7 Training sets your pace and power targets, and how to adjust for hills, heat and fatigue.",
    eyebrow: "Using PX7 Training",
    readMinutes: 4,
    date: "2026-10-10",
  },
  {
    slug: "easy-is-an-intensity",
    title: "How easy should an easy run be?",
    description:
      "Use breathing and effort to keep easy runs comfortable. How to use a pace ceiling and adjust for hills, heat or tired legs.",
    eyebrow: "Using PX7 Training",
    readMinutes: 3,
    date: "2026-10-10",
  },
];

export const articleMetaBySlug = Object.fromEntries(
  articleMetas.map((meta) => [meta.slug, meta]),
) as Record<string, ArticleMeta>;
